export type PrefetchMode = 'always' | 'intent' | 'guarded' | 'never';

interface PrefetchCapability {
  canPrefetch: boolean;
}

interface PrefetchContext {
  effectiveType?: string | null;
  isAuthenticated?: boolean;
  isExternal: boolean;
  saveData?: boolean;
}

const SLOW_CONNECTIONS = new Set(['slow-2g', '2g']);

export function shouldSchedulePrefetch(
  mode: PrefetchMode,
  context: PrefetchContext,
): boolean {
  if (mode === 'never' || context.isExternal) {
    return false;
  }

  if (mode === 'guarded' && !context.isAuthenticated) {
    return false;
  }

  if (context.saveData || SLOW_CONNECTIONS.has(context.effectiveType ?? '')) {
    return mode === 'always';
  }

  return true;
}

export function getLinkPrefetchProp(
  mode: PrefetchMode,
  { canPrefetch }: PrefetchCapability,
): boolean | undefined {
  if (!canPrefetch) {
    return false;
  }

  return mode === 'always' ? undefined : false;
}
